import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import ScrollToTopButton from '../../components/feature/ScrollToTopButton';

export default function PoliticaCookiesPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-1 py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-[#544E13] mb-8">Política de cookies</h1>
          
          <div className="prose prose-lg max-w-none text-gray-700">
            <p className="text-lg mb-6">
              Última actualización: {new Date().toLocaleDateString('es-ES')}
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#544E13] mb-4">¿Qué son las cookies?</h2>
              <p className="mb-4">
                Las cookies son pequeños archivos de texto que se almacenan en su dispositivo cuando visita nuestro sitio web. 
                Estas cookies nos ayudan a mejorar su experiencia de navegación y a proporcionar funcionalidades específicas.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#544E13] mb-4">Tipos de cookies que utilizamos</h2>
              
              <h3 className="text-xl font-semibold text-[#544E13] mb-3">Cookies técnicas</h3>
              <p className="mb-4">
                Son necesarias para el funcionamiento básico del sitio web. Permiten la navegación y el uso de diferentes 
                opciones o servicios que existen en la web.
              </p>

              <h3 className="text-xl font-semibold text-[#544E13] mb-3">Cookies de análisis</h3>
              <p className="mb-4">
                Nos permiten conocer el número de visitantes y cómo los usuarios utilizan nuestro sitio web, 
                lo que nos ayuda a mejorar el funcionamiento de la página.
              </p>

              <h3 className="text-xl font-semibold text-[#544E13] mb-3">Cookies de personalización</h3>
              <p className="mb-4">
                Permiten recordar información para que el usuario acceda al servicio con determinadas características 
                que pueden diferenciar su experiencia de la de otros usuarios.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#544E13] mb-4">Cookies de terceros</h2>
              <p className="mb-4">
                Nuestro sitio web puede utilizar cookies de terceros para mejorar nuestros servicios:
              </p>
              <ul className="list-disc pl-6 mb-4">
                <li>Google Analytics: Para analizar el uso del sitio web</li>
                <li>Google Maps: Para mostrar mapas interactivos</li>
                <li>WhatsApp: Para el botón de contacto directo</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#544E13] mb-4">Gestión de cookies</h2>
              <p className="mb-4">
                Puede aceptar o rechazar las cookies, así como eliminar las que ya se hayan instalado en su equipo 
                mediante la configuración de las opciones del navegador instalado en su ordenador.
              </p>
              <p className="mb-4">
                Para más información sobre cómo gestionar las cookies en los navegadores más populares:
              </p>
              <ul className="list-disc pl-6 mb-4">
                <li>Chrome: Configuración &gt; Privacidad y seguridad &gt; Cookies</li>
                <li>Firefox: Opciones &gt; Privacidad y seguridad &gt; Cookies</li>
                <li>Safari: Preferencias &gt; Privacidad &gt; Cookies</li>
                <li>Edge: Configuración &gt; Cookies y permisos del sitio</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#544E13] mb-4">Consentimiento</h2>
              <p className="mb-4">
                Al continuar navegando por nuestro sitio web, usted acepta el uso de cookies de acuerdo con esta política. 
                Si no está de acuerdo con el uso de cookies, puede configurar su navegador para rechazarlas.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#544E13] mb-4">Contacto</h2>
              <p className="mb-4">
                Si tiene alguna pregunta sobre nuestra política de cookies, puede contactarnos:
              </p>
              <ul className="list-none mb-4">
                <li className="mb-2">
                  <strong>Email:</strong> info@restaurax.com
                </li>
                <li className="mb-2">
                  <strong>Teléfono:</strong> 690 22 09 44
                </li>
                <li className="mb-2">
                  <strong>Dirección:</strong> Hospitalet de Llobregat, Barcelona
                </li>
              </ul>
            </section>
          </div>
        </div>
      </main>

      <Footer />
      <WhatsAppButton />
      <ScrollToTopButton />
    </div>
  );
}